import { render, staticRenderFns } from "./detailBGLobby.vue?vue&type=template&id=8ad66044&scoped=true"
import script from "./detailBGLobby.vue?vue&type=script&lang=js"
export * from "./detailBGLobby.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad66044",
  null
  
)

export default component.exports